export default "__VITE_ASSET__f9379e1e__"